export const card = { marginTop: "10px", marginBottom: "10px" };
